module.exports = __webpack_public_path__ + "static/media/3piechart.fdafa751.png";